import { render, staticRenderFns } from "./WorkshopListModal.vue?vue&type=template&id=0a55e554"
import script from "./WorkshopListModal.vue?vue&type=script&lang=js"
export * from "./WorkshopListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports